import { SweetAlertIcon } from 'sweetalert2';
import { SweetAlertEnums } from 'utils/enums';

interface propType {
  showSweetAlert: boolean;
  sweetAlertType: number;
  iconName?: SweetAlertIcon;
  callAFunc?: any;
  title: string;
  subTitle: string;
  confirmButtonText?: string;
  timeOut?: number;
  cancelFunc?: any;
  cancelButtonText?: string;
  confirmButtonColor?: string;
  cancelButtonColor?: string;
}

const TIME_OUT = 2000;

const SweetAlert = async (props: propType) => {
  const {
    showSweetAlert,
    sweetAlertType,
    iconName,
    title,
    subTitle,
    confirmButtonText,
    timeOut,
    cancelButtonText,
    confirmButtonColor,
    cancelButtonColor,
  } = props;

  if (!showSweetAlert) return;

  // sweetalert2 only downloaded when an alert actually needs to fire
  const { default: Swal } = await import('sweetalert2');

  const darkOptions = {
    background: 'var(--app-surface)',
    color: 'var(--app-text)',
  };

  switch (sweetAlertType) {
    case SweetAlertEnums?.success:
      Swal.fire({
        ...darkOptions,
        customClass: { container: 'my-swal' },
        title: title,
        text: subTitle,
        icon: iconName || 'success',
        confirmButtonColor: 'var(--gallop-bg-primary)',
        timer: timeOut || TIME_OUT,
        timerProgressBar: true,
      });
      break;
    case SweetAlertEnums?.error:
      Swal.fire({
        ...darkOptions,
        customClass: { container: 'my-swal' },
        title: title,
        text: subTitle,
        icon: iconName || 'error',
        confirmButtonColor: 'var(--gallop-bg-primary)',
        timer: timeOut || TIME_OUT,
        timerProgressBar: true,
      });
      break;
    case SweetAlertEnums?.confirm:
      Swal.fire({
        ...darkOptions,
        customClass: { container: 'my-swal' },
        title: title,
        text: subTitle,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: confirmButtonColor || 'var(--gallop-bg-primary)',
        cancelButtonColor: cancelButtonColor || '#d33',
        cancelButtonText: cancelButtonText || 'Cancel',
        confirmButtonText: confirmButtonText || 'Yes, delete it!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await props.callAFunc();
        } else if (
          result.isDenied ||
          result.dismiss === Swal.DismissReason.cancel
        ) {
          if (props.cancelFunc) {
            await props.cancelFunc();
          }
        }
      });
      break;
    default:
      break;
  }
};

export default SweetAlert;
